export default __webpack_public_path__ + "static/media/bell_outlined.b628eb99.svg";